// extracted by mini-css-extract-plugin
module.exports = {"aboutPageWrapper":"About_aboutPageWrapper__1R3ap","aboutPage":"About_aboutPage__2tx8v","topImage":"About_topImage__36JvX"};